// EnableDeviceLocationModal.tsx
import React from "react";
import { useLocationAccess } from "../../contexts/LocationContext";
import inPopup from "../../utils/hoc/inPopup";
import { getPlatform } from "../../utils/platformUtil";

const EnableDeviceLocation: React.FC<{ isActive: boolean; onClose: () => void; }> = ({ onClose }) => {
    const platform = getPlatform();

    return (
        <div className="p-3">
            <div className="modal-header border-0">
                <h4 className="modal-title fw-bold">Turn on device location </h4>
                <button type="button" className="btn-close rounded-circle bg-light" onClick={onClose}></button>
            </div>

            <div className="modal-body py-3 pb-0">
                {[
                    "Go to Settings",
                    ...(platform === 'android' ? ["Select Location from list"] : ["Select Privacy and Security", "Select Location Services",]),
                    "Turn on Location Services",
                ].map((text, index) => (
                    <div key={index} className="d-flex align-items-center mb-2">
                        <div className="rounded-circle bg-light d-flex justify-content-center align-items-center"
                            style={{ width: 32, height: 32 }}>
                            <span className="fw-bold">{index+1}</span>
                        </div>
                        <span className="ms-2 fs-7">{text}</span>
                    </div>
                ))}
            </div>
            <div className="divider my-3"></div>
            <div className="border-0 d-flex justify-content-start gap-2">
                <button className="btn btn-sm w-100 theme-btn-primary rounded-sm" onClick={onClose}>Ok! Got it</button>
            </div>
        </div>
    )
}

const EnableDeviceLocationPopup = inPopup(EnableDeviceLocation);

const EnableDeviceLocationModal: React.FC = () => {
    const { showDeviceLocationPopup: show, hideDeviceLocationPopup } = useLocationAccess();
    return (
        <EnableDeviceLocationPopup isActive={show} onClose={hideDeviceLocationPopup} />
    );
};

export default EnableDeviceLocationModal;
